import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppConfig } from "./app.config";
import { GlobalService } from "../providers/global.service";
import * as jwt_decode from "jwt-decode";
import { HttpClient, HttpResponse } from "@angular/common/http";

@Injectable()
export class TokenService {
  constructor(
    private http: HttpClient,
    private storage: Storage,
  ) {}

  DesignationsList: any = [
    { id: 0, name: "Admin", value: 0, selected: true },
    { id: 1, name: "Sachiv", value: 1, selected: false },
    { id: 2, name: "Sarpanch", value: 2, selected: false },
    { id: 3, name: "BDPO", value: 3, selected: false },
    { id: 4, name: "Chairman", value: 4, selected: false },
    { id: 5, name: "CEO", value: 5, selected: false },
    { id: 6, name: "President", value: 6, selected: false },
    { id: 7, name: "DDPO", value: 7, selected: false },
    { id: 8, name: "XEN", value: 8, selected: false },
    { id: 9, name: "State Admin", value: 9, selected: false },
    { id: 10, name: "Super Admin", value: 10, selected: false },
  ];

  RolesList: any = [
    { id: 0, name: "Select", value: "Select", selected: true },
    { id: 1, name: "Admin", value: 1, selected: false },
    { id: 2, name: "Maker", value: 2, selected: false },
    { id: 3, name: "Checker", value: 3, selected: false },
    { id: 4, name: "Viewer", value: 4, selected: false },
    { id: 5, name: "Super Admin", value: 5, selected: false },
  ];

  getTokenExpirationDate(token: string): Date {
    const decoded = jwt_decode(token);

    if (decoded.exp === undefined) return null;

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  isTokenExpired(token?: string): boolean {
    if (!token) return true;

    const date = this.getTokenExpirationDate(token);
    if (date === undefined) return false;
    return !(date.valueOf() > new Date().valueOf());
  }

  public refreshToken(refreshToken: any): Observable<any> {
    var d =
      "grant_type=refresh_token&refresh_token=" +
      refreshToken +
      "&client_id=" +
      AppConfig.clientId;
    return this.http.post(AppConfig.baseUrl + "token", d).pipe(
      map((response: any) => {
        var res = response.json();
        if (res && res.access_token) this.setUser(res);
        return GlobalService.user;
      }),
    );
  }

  public getAccessToken(): Promise<string> {
    return this.storage.get("user").then((user: any) => {
      if (!user) {
        return null;
      } else if (this.isTokenExpired(user.access_token)) {
        this.refreshToken(user.refresh_token).subscribe(
          (user) => {
            return user.access_token; //return new access_token
          },
          (error) => {
            return user.access_token; // if error send old access_token and then let it error 401
          },
        );
      } else {
        return user.access_token; //token not expired
      }
    });
  }

  public setUser(res: any): any {
    let user = jwt_decode(res.access_token);
    user.access_token = res.access_token;
    user.refresh_token = res.refresh_token;
    user.session_proof = res.session_proof;

    let Role = user ? user.Role : -1;
    let Designation = user ? user.Designation : -1;

    this.storage.set("user", user);
    GlobalService.user = user;
    return user;
  }
}
